import { cva } from "class-variance-authority";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "dark:border-transparent dark:bg-primary dark:text-primary-foreground dark:hover:bg-primary/80 border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "dark:border-transparent dark:bg-secondary dark:text-secondary-foreground dark:hover:bg-secondary/80 border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "dark:border-transparent dark:bg-destructive dark:text-destructive-foreground dark:hover:bg-destructive/80 border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export { badgeVariants };
